import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InviteOwnRespondentsSchema } from '../types/inviteOwnRespondentSchema';
import {
  fetchInviteAccept,
  fetchInviteCompany,
} from '../services/ownRespondentInviteServices';
import NetworkError from 'shared/exceptions/network';

const initialState: InviteOwnRespondentsSchema = {
  actions: {
    invite_hash: undefined,
  },
  invite_company: {
    data: {},
    loading: false,
  },
  accept_invite: {
    isAccepted: false,
    loading: false,
  },
};

export const ownRespondentInviteSlice = createSlice({
  name: 'ownRespondentInvite',
  initialState,
  reducers: {
    setInviteHash(state, action: PayloadAction<string | undefined>) {
      state.actions.invite_hash = action.payload;
    },
  },
  extraReducers: builder => {
    // ownRespondentInvite/fetchInviteCompany
    builder
      .addCase(fetchInviteCompany.pending, state => {
        state.invite_company.loading = true;
        state.invite_company.error = undefined;
      })
      .addCase(fetchInviteCompany.fulfilled, (state, action) => {
        state.invite_company.loading = false;
        state.invite_company.error = undefined;
        state.invite_company.data = action.payload.data.data;
      })
      .addCase(fetchInviteCompany.rejected, (state, action) => {
        state.invite_company.loading = false;
        const message = (action.payload as NetworkError).message;
        state.invite_company.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });

    // ownRespondentInvite/fetchInviteCompany
    builder
      .addCase(fetchInviteAccept.pending, state => {
        state.accept_invite.loading = true;
        state.accept_invite.error = undefined;
      })
      .addCase(fetchInviteAccept.fulfilled, state => {
        state.accept_invite.loading = false;
        state.accept_invite.error = undefined;
        state.accept_invite.isAccepted = true;
      })
      .addCase(fetchInviteAccept.rejected, (state, action) => {
        state.accept_invite.loading = false;
        const message = (action.payload as NetworkError).message;
        state.accept_invite.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });
  },
});
export const { actions: ownRespondentInviteActions } = ownRespondentInviteSlice;
export const { reducer: ownRespondentInviteReducer } = ownRespondentInviteSlice;
